import React from "react";
import Container from "../layout/Container";
import Reveal from "../motion/Reveal";
import { Cal, Pip, Rate } from "../characters/Character";
import { Ground, Squircle } from "../characters/Decor";
import { useI18n } from "../../i18n/I18nProvider";

const CHARACTERS = [Cal, Rate, Pip];

const Loop = () => {
  const { t } = useI18n();
  const steps = [1, 2, 3].map((n, index) => ({
    n,
    title: t(`loop.s${n}Title`),
    body: t(`loop.s${n}Body`),
    Character: CHARACTERS[index],
  }));

  return (
    <section className="wash-sky relative overflow-hidden py-16 md:py-24">
      <Squircle className="pointer-events-none absolute -right-10 top-8 hidden h-32 w-32 md:block" />
      <Container>
        <Reveal>
          <p className="text-body font-medium text-accent">{t("loop.kicker")}</p>
          <h2 className="mt-3 max-w-2xl text-heading font-bold tracking-heading text-ink md:text-heading-lg">
            {t("loop.title")}
          </h2>
        </Reveal>
        <div className="mt-16 grid gap-12 md:grid-cols-3 md:gap-5">
          {steps.map((step, index) => (
            <Reveal key={step.n} delay={index * 0.08}>
              <article className="relative h-full rounded-card border border-hairline bg-paper p-6 pt-12 shadow-card transition-transform duration-200 hover:-translate-y-1 hover:shadow-lift">
                <div className="absolute -top-8 left-6">
                  <Ground className="absolute -bottom-1 left-1/2 w-16 -translate-x-1/2" />
                  <step.Character size={72} decorative />
                </div>
                <h3 className="text-subheading font-semibold text-ink">{step.title}</h3>
                <p className="mt-3 text-body text-mid-gray">{step.body}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Loop;
